/*
 * File: /src/router/routes/guidbooks.js
 * Created Date: Saturday January 11th 2025
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Saturday, 11th January 2025 7:18:52 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2025 AdBase, Inc.
 */

const GuidebookList = () =>
  import(
    /* webpackChunkName: "Guidebooks" */ 'src/components/Dashboard/Views/Guidebooks/GuidebookList.vue'
  );
const GuidebookBlockList = () =>
  import(
    /* webpackChunkName: "Guidebooks" */ 'src/components/Dashboard/Views/Guidebooks/GuidebookBlockList.vue'
  );
const GuidebookEdit = () =>
  import(
    /* webpackChunkName: "Guidebooks" */ 'src/components/Dashboard/Views/Guidebooks/GuidebookEdit.vue'
  );
const GuidebookBlockEdit = () =>
  import(
    /* webpackChunkName: "Guidebooks" */ 'src/components/Dashboard/Views/Guidebooks/GuidebookBlockEdit.vue'
  );
const GuidebookHoursGrid = () =>
  import(
    /* webpackChunkName: "Guidebooks" */ 'src/components/Dashboard/Views/Guidebooks/GuidebookHoursGrid.vue'
  );
const GuidebookThemeList = () =>
  import(
    /* webpackChunkName: "Guidebooks" */ 'src/components/Dashboard/Views/Guidebooks/GuidebookThemeList.vue'
  );
const GuidebookThemeEdit = () =>
  import(
    /* webpackChunkName: "Guidebooks" */ 'src/components/Dashboard/Views/Guidebooks/GuidebookThemeEdit.vue'
  );

export const guidebookRoutes = [
  {
    path: 'guidebook-hours',
    name: 'Guidebook Hours',
    component: GuidebookHoursGrid,
  },
  {
    path: 'guidebook-themes/list',
    name: 'Guidebook Theme List',
    component: GuidebookThemeList,
  },
  {
    path: 'guidebook-themes/add',
    name: 'Guidebook Theme Add',
    component: GuidebookThemeEdit,
  },
  {
    path: 'guidebook-themes/edit/:id',
    name: 'Guidebook Theme Edit',
    component: GuidebookThemeEdit,
    props: (route) => ({
      id: parseInt(route.params.id),
    }),
  },
  {
    path: 'guidebook-block/edit/:id',
    name: 'Guidebook Block Edit',
    component: GuidebookBlockEdit,
    props: (route) => ({
      id: parseInt(route.params.id),
    }),
  },

  {
    path: 'guidebook-block/add',
    name: 'Guidebook Block Add',
    component: GuidebookBlockEdit,
  },
  {
    path: 'guidebook-block/list',
    name: 'Guidebook Block List',
    component: GuidebookBlockList,
  },
  {
    path: 'guidebooks/edit/:id',
    name: 'Guidebook Edit',
    component: GuidebookEdit,
    props: (route) => ({
      id: parseInt(route.params.id),
    }),
  },
  {
    path: 'guidebooks/list',
    name: 'Guidebook List',
    component: GuidebookList,
  },
  {
    path: 'guidebooks/add',
    name: 'Guidebook Add',
    component: GuidebookEdit,
    props: (route) => ({
      id: undefined,
    }),
  },
];
